import { useForm } from 'react-hook-form';

import { mockOrderFormCategories } from 'support/data/mockOrderFormData';
import { OrderData } from 'support/helpers/orderForms/orderForms';
import { OrderFormContent } from 'pages/OrderForm/components/OrderFormContent/OrderFormContent';
import { OrderFormHeaderContent } from 'pages/OrderForm/components/OrderFormHeaderContent/OrderFormHeaderContent';
import { OrderFormSidebar } from 'pages/OrderForm/components/OrderFormSidebar/OrderFormSidebar';
import { OrderFormPageLayout } from 'components/OrderFormPageLayout/OrderFormPageLayout';

export const OrderFormAuthLayoutBackgroundContent = () => {
  const formMethods = useForm<OrderData>({
    defaultValues: {
      products: {},
    },
  });

  return (
    <OrderFormPageLayout
      headerContent={<OrderFormHeaderContent />}
      sidebar={<OrderFormSidebar categories={mockOrderFormCategories} />}
    >
      <OrderFormContent
        categories={mockOrderFormCategories}
        formMethods={formMethods}
        className="pointer-events-none select-none"
      />
    </OrderFormPageLayout>
  );
};
